module.exports = __webpack_public_path__ + "img/order.763a6547.png";